import React, { useEffect, useState } from "react";
import { checkUserAuth, auth } from "../../firebase";
import { useNavigate, useParams } from "react-router-dom";
import { Box, CssBaseline, Grid } from "@mui/material";
import { Typography, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import logoImage from "../../assets/images/logoblue.png";
import {
  createContributorDoc,
  getContributorInvite,
  updateContributorInvite,
} from "../../modules/Contributors/hooks/ContributorsHook";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { routes, showNotification } from "../../constants";
import { useAuth } from "../../hooks";

export default function AcceptContributorInvite() {
  const navigate = useNavigate();
  const {
    onLogout,
    setIsLoggedIn,
    setCurrentAuth,
    setCurrentUser,
    currentAuth,
  } = useAuth();
  const [statusMessage, setStatusMessage] = useState("");
  // const [statusMessage, setStatusMessage] = useState("Please wait...");
  const { ref, status } = useParams();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(true);
  // const [showForm, setShowForm] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  // const [isAuthentication, setIsAuthentication] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  let isAuthentication = false;

  console.log("id::", ref);

  // useEffect(() => {
  //   if (currentAuth) {
  //     setLoading(true);
  //     // setTimeout(() => {
  //       onLogout();
  //       // setIsLoggedIn(false);
  //       // setCurrentAuth(null);
  //       // setCurrentUser(null);
  //     // }, 3000);
  //     setLoading(false);
  //   }
  //   //commented out because I changed the whole logic of adding contributor
  //   // handleCheckUserAuth();
  // }, [currentAuth]);

  useEffect(() => {
    // Check if there is a currently logged-in user
    if (auth.currentUser) {
      // Log out the current user
      onLogout();
    }
  }, []);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleCheckUserAuth = async () => {
    try {
      //generate auth, get data from contributor, update user doc
      let response = await checkUserAuth({ id: ref });
      console.log("response", response?.data?.result?.email);
      if (response?.data?.result?.email) {
        isAuthentication = true;
        // handleUpdateUser();
        console.log("User is authenticated");
      } else {
        setStatusMessage("");
        setShowForm(true);
        console.log("User is not authenticated");
      }
      // let response = await checkUserAuth({ id: ref });
      // console.log("response", response?.data?.result?.email);
      // if (response?.data?.result?.email) {
      //   isAuthentication = true;
      //   handleUpdateUser();
      //   console.log("User is authenticated");
      // } else {
      //   setStatusMessage("");
      //   setShowForm(true);
      //   console.log("User is not authenticated");
      // }
    } catch (error) {
      setShowForm(true);
      setStatusMessage("");
      console.log("error checking user auth", error.message);
    }
  };

  const handleUpdateUser = async (event) => {
    if (event) {
      event.preventDefault();
    }
    try {
      if (ref) {
        setLoading(true);
        if (event) {
          if (!password || password.length < 6) {
            setPasswordError("Password must be at least 6 characters");
            alert("Password must be at least 6 characters");
            setLoading(false);
            return;
          } else {
            setPasswordError("");
          }
        }
        //get user data from contributorsInvites, then  create user auth in firebase, then create user doc in users collection
        const inviteData = await getContributorInvite(ref);
        let userData = inviteData?.data();
        // let name = inviteData?.data().firstName?.split(" ");

        let authResponse = await createUserWithEmailAndPassword(
          auth,
          userData?.invitedUserEmail,
          password
        );
        let uid = authResponse.user.uid;
        let data = {
          email: userData?.invitedUserEmail,
          organizations: [userData?.organization],
          // approvalStatus: {
          //   status: "accepted",
          //   // status: status == "accepted" ? "accepted" : "declined",
          //   updatedAt: new Date(),
          //   updatedBy: uid,
          // },
          firstName: inviteData?.data().firstName
            ? inviteData?.data().firstName
            : "",
          lastName: inviteData?.data().lastName
            ? inviteData?.data().lastName
            : "",
          // firstName: name && name[0] ? name[0] : "",
          // lastName: name && name[1] ? name[1] : "",
          invitedBy: userData?.invitedBy,
          userName: "",
          createdAt: new Date(),
          updatedAt: new Date(),
          isActive: true,
          // addedToOrgDate: new Date(),
          // invitationToOrgDate: new Date(),
        };
        let statusUpdateData = {
          status: "accepted",
          userId: uid,
          updatedAt: new Date(),
        };
        let docResponse = await createContributorDoc(data, uid);
        let updateInviteResponse = await updateContributorInvite(
          statusUpdateData,
          ref
        );
        console.log("contributor doc created:", docResponse);
        console.log("updated Invite contributor res:", updateInviteResponse);
        setShowForm(false);
        setStatusMessage(`Thank you. Invite ${status} successfully.`);
        showNotification(
          "You have successfully accepted the invite, Welcome to the Organization, please close this page"
        );
        // navigate(routes.login);

        setLoading(false);
      }
    } catch (error) {
      handleAuthError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAuthError = (error) => {
    if (error.code === "auth/email-already-in-use") {
      showNotification("Email already in use, cannot create new user.");
    } else if (error.code === "auth/operation-not-allowed") {
      showNotification(
        "Operation not allowed. Please enable Email/Password sign-in in the Firebase console."
      );
    } else if (error.code === "auth/weak-password") {
      setPasswordError("The password is too weak.");
    } else {
      showNotification(`Failed to create user: ${error.message}`);
    }
  };

  return (
    <Box>
      <Box sx={mainContainerStyles}>
        <CssBaseline />

        <Grid
          container
          direction="column"
          alignItems="center"
          spacing={2}
          maxWidth="336px"
        >
          <Grid item>
            <img src={logoImage} alt="Logo" style={logoStyles} />
          </Grid>

          {showForm ? (
            <form onSubmit={handleUpdateUser}>
              <Grid
                item
                display={"flex"}
                flexDirection="column"
                gap={"4px"}
                spacing={2}
                width="100%"
                marginTop="10px"
              >
                <Typography>Set Your Password</Typography>
                <div style={{ position: "relative", width: "100%" }}>
                  <input
                    type={showPassword ? "text" : "password"}
                    // value={password}
                    // onChange={handlePasswordChange}
                    variant="outlined"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    error={!!passwordError}
                    helperText={passwordError}
                    placeholder="Enter your password"
                    style={{
                      ...textfieldStyles,
                      marginBottom: "10px",
                    }}
                  />
                  <div style={passwordIconStyles}>
                    <IconButton onClick={togglePasswordVisibility} edge="end">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </div>
                </div>
              </Grid>
              <Grid item width={"336px"} marginTop="15px">
                <LoadingButton
                  variant="contained"
                  color="primary"
                  type="submit"
                  loading={loading}
                  // onClick={handleSubmit}
                  style={loginButtonStyles}
                >
                  Submit
                </LoadingButton>
                {statusMessage}
              </Grid>
            </form>
          ) : (
            <div>{statusMessage}</div>
          )}
        </Grid>
      </Box>
    </Box>
  );
}

const mainContainerStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
};
const passwordIconStyles = {
  position: "absolute",
  top: "42%",
  right: "13px",
  transform: "translateY(-50%)",
};
const logoStyles = { width: "335.99px", height: "86px", color: "#00A7CD" };
const textfieldStyles = {
  width: "100%",
  height: "48px",
  borderRadius: "8px",
  border: "2px solid #00A7CD",
  fontSize: "16px",
  padding: "12px",
};
const loginButtonStyles = {
  width: "100%",
  height: "34px",
  borderRadius: "4px",
  backgroundColor: "#00A7CD",
};
